import React from 'react';
import Header from '../header';
import Footer from '../footer';
import { Outlet } from 'react-router-dom';
import { FloatingContact } from 'src/components';

const MainLayout = () => {
	return (
		<div className='min-h-screen flex flex-col'>
			<Header />
			<div className='flex-1 bg-[#f0f7ff]'>
				<Outlet />
			</div>
			<Footer />
			<FloatingContact />
		</div>
	);
};

export default MainLayout;
